import PropTypes from 'prop-types';
import React from 'react';
import Select from 'react-select';
import SelectAsync from 'react-select/async';
import { Label } from 'rebass';

import config from 'frontend/config';

const ReactSelect = (props) => {
  let SelectComponent = Select;
  if (props.async) {
    SelectComponent = SelectAsync;
  }
  return (
    <div>
      <Label color={props.labelColor}>{props.label}</Label>
      <SelectComponent
        style={{
          color: config.color.white,
          backgroundColor: props.backgroundColor,
          lineHeight: '36px',
          border: 0,
          minWidth: props.minWidth,
        }}
        styles={{
          control: base => ({
            ...base,
            color: config.color.white,
            backgroundColor: props.backgroundColor,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: 'rgba(255, 255, 255, 0.19)',
            borderRadius: 5,
            height: 40,
          }),
          option: (base, state) => {
            let backgroundColor = '#222';
            if (state.isSelected) {
              backgroundColor = 'rgba(255, 187, 51, 0.1)';
            } else if (state.isFocused) {
              backgroundColor = '#111';
            }
            return {
              ...base,
              color: config.color.white,
              backgroundColor,
            };
          },
          input: base => ({
            ...base,
            color: config.color.white,
            backgroundColor: props.backgroundColor,
          }),
          singleValue: base => ({
            ...base,
            color: config.color.white,
            backgroundColor: props.backgroundColor,
          }),
          placeholder: base => ({
            ...base,
            color: '#aaa',
            backgroundColor: props.backgroundColor,
          }),
          menu: base => ({
            ...base,
            color: config.color.white,
            backgroundColor: '#222',
            borderColor: config.color.white,
            borderWidth: 1,
            borderStyle: 'solid',
          }),
        }}
        {...props}
      />
    </div>
  );
};

ReactSelect.propTypes = {
  label: PropTypes.string,
  labelColor: PropTypes.string,
  async: PropTypes.bool,
  minWidth: PropTypes.string,
  backgroundColor: PropTypes.string,
};

ReactSelect.defaultProps = {
  label: '',
  labelColor: undefined,
  async: false,
  minWidth: null,
  backgroundColor: config.colors.primary,
};

export default ReactSelect;
